import React, { useCallback, useState } from "react";
import { Formik, Form } from "formik";
import { Loader, toast } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes, initialValues } from "../constants";
import { StatusField } from "../fields";
import { FormButton, LinkButton } from "../components";
import { createPreIntakeStatus } from "../../pre-intake/apis";
import { useInitialState } from "../contexts/initial-state-context";
import validationSchema from "../validations/validationSchema";

const PreIntakeStatusForm = React.memo(({ onCancel }) => {
  const [loading, setLoading] = useState(false);
  const { consultation, loadConsultation } = useInitialState();
  const { preIntakeStatusCode } = consultation;

  const handleSubmit = useCallback(async (values, { resetForm }) => {
    setLoading(true);

    const { success } = await createPreIntakeStatus({
      consultationId: consultation.globalId,
      statusCd: values[fieldTypes.STATUS].value,
    });

    if (success) {
      toast.success({
        description: translate(null, "pre_intake.notifications", "status_changed"),
      });

      await loadConsultation();

      resetForm();
      setLoading(false);
    }
  }, [consultation, loadConsultation]);

  return (
    <React.Fragment>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {() => (
          <Form>
            <StatusField />

            {preIntakeStatusCode && (
              <LinkButton onClick={onCancel}>
                {translate(null, "pre_intake.actions", "cancel")}
              </LinkButton>
            )}

            <FormButton>
              {translate(null, "pre_intake.actions", "save")}
            </FormButton>
          </Form>
        )}
      </Formik>

      {loading && (
        <Loader
          width={32}
          height={32}
        />
      )}
    </React.Fragment>
  );
});

PreIntakeStatusForm.displayName = "PreIntakeStatusForm";

export default PreIntakeStatusForm;
